/*
 * <product-modal>: Obraven image lightbox (snippets/product-media-modal.liquid), built on Dawn's
 * ModalDialog (global.js: focus trap, Esc, focus return). Opens scrolled to the media the gallery's
 * zoom button points at (data-media-id).
 */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const items = this.querySelectorAll('[data-media-id]');
        items.forEach((element) => element.classList.toggle('active', element.dataset.mediaId === mediaId));

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const container = this.querySelector('[role="document"]');
        if (container) {
          const padding = parseFloat(getComputedStyle(container).paddingTop) || 0;
          container.scrollTop = activeMedia.offsetTop - container.offsetTop - padding;
        }

        const deferred = activeMedia.querySelector('deferred-media');
        if (deferred?.querySelector('template')?.content.querySelector('.js-youtube')) deferred.loadContent(false);
      }
    }
  );
}
